import FullScreenOverlay from '../../../Components/FullScreenOverlay/FullScreenOverlay';
import { get, post } from '../../../Services/api';
import loading_display from '../../../Utility/loading_display';
import './SelectedIngredientModal.css'


function SelectedIngredientModal({ selected_ingredients, ingredientsSelectedAction, setIngredientsSelectedAction, selectedIngredientFunc, checkIngredientChecked, getAllSelectedIngredients }) {

    async function generateImage(all_ingredients) {
        if (window.confirm('Are you sure?')) {
            loading_display(true)
            for (let i = 0; i < selected_ingredients.length; i++) {
                const ingredient = selected_ingredients[i]

                if (all_ingredients || !ingredient.image) {
                    // generate image
                    const result = await get('/api/admin/ingredient/generate-ingredients-image?ingredient_name=' + ingredient.name + '&ingredient_id=' + ingredient.ingredient_id)
                }
            }
            // get all ingredients again
            await getAllSelectedIngredients()

            loading_display(false)
        }
    }


    async function generateCost() {
        loading_display(true)
        // generate cost
        const result = await post('/api/admin/ingredient/generate-ingredients-cost', {
            ingredient_id_array: selected_ingredients.map(ingredient => ingredient.ingredient_id),
            currency_code: 'USD',
            country_code: 'US'
        })
        // get all ingredients again
        await getAllSelectedIngredients()

        loading_display(false)
    }

    async function generateNutritionInfo() {
        loading_display(true)
        // generate nutrition info
        const result = await post('/api/admin/ingredient/regenerate-ingredient-detail', {
            ingredient_id_array: selected_ingredients.map(ingredient => ingredient.ingredient_id),
        })
        // get all ingredients again
        await getAllSelectedIngredients()

        loading_display(false)
    }

    async function deleteIngredient() {
        if (window.confirm('Are you sure?')) {
            loading_display(true)
            try {
                // set subscriber status
                const result = await post('/api/admin/ingredient/delete-ingredient', {
                    ingredient_id_array: selected_ingredients.map((ingredient) => ingredient.ingredient_id)
                })

                if (result.ingredients) alert('Error deleting ingredient. These ingredients are in use: ' + result.ingredients)
            } catch (error) {
                console.log(error)
                alert('Error deleting ingredient. Most likely it is in use by a user.')
            }

            // get all ingredients again
            await getAllSelectedIngredients()

            loading_display(false)
        }
    }

    return (
        <div>
            <FullScreenOverlay modalOpen={ingredientsSelectedAction} setModalOpen={setIngredientsSelectedAction}>
                <div className='admin_ingredients_selected_ingredients_action_div'>
                    <div className="flex gap_12">
                        <div className='flex flex_column gap_6'>
                            <button className="admin_ingredients_indiv_ingredient_action_button cursor_pointer" onClick={() => generateCost(true)}>Generate Cost</button>
                        </div>
                        <div className='flex flex_column gap_6'>
                            <button className="admin_ingredients_indiv_ingredient_action_button cursor_pointer" onClick={() => generateNutritionInfo(true)}>Generate Nutrition Info</button>
                        </div>
                        <div className='flex flex_column gap_6'>
                            <button className="admin_ingredients_indiv_ingredient_action_button cursor_pointer" onClick={() => generateImage(true)}>Generate Image For All</button>
                            <button className="admin_ingredients_indiv_ingredient_action_button cursor_pointer" onClick={() => generateImage(false)}>Generate Image For Ones With No Image</button>
                        </div>

                        <div className='flex flex_column gap_6'>
                            <p className='admin_ingredients_indiv_filter_attention_selected' onClick={() => deleteIngredient()}>Delete Ingredients</p>
                        </div>
                    </div>

                    <div className='admin_ingredients_selected_ingredients_action_div_ingredient_list'>
                        <div className='gray_scale_1 admin_ingredients_list_indiv_ingredient'>
                            <p></p>
                            <p className='font_size_16'>Image</p>
                            <p className='font_size_16'>Name</p>
                            <p className='font_size_16'>Restrictions</p>
                            <p className='font_size_16'>Cost</p>
                            <p className='font_size_16'>Unit</p>
                            <p className='font_size_16'>Cal</p>
                            <p className='font_size_16'>Carb</p>
                            <p className='font_size_16'>Fat</p>
                            <p className='font_size_16'>Protein</p>
                        </div>
                        {selected_ingredients.map((ingredient, i) => (
                            <div key={i} className={('admin_ingredients_list_indiv_ingredient') + ' admin_ingredients_list_indiv_ingredient_' + (i % 2)}>
                                <input onChange={(e) => selectedIngredientFunc(ingredient, e.target.checked)} checked={checkIngredientChecked(ingredient)} type='checkbox' className='admin_ingredients_list_indiv_ingredient_checkbox cursor_pointer' />

                                {ingredient.image ? <img src={ingredient.image} className='admin_ingredients_list_indiv_ingredient_img' /> : <div></div>}

                                <p className='gray_scale_1 font_size_20 word_break gray_scale_1'>{ingredient.name}</p>

                                <p className='font_size_16 word_break gray_scale_1'>{ingredient.restriction}</p>
                                <p className='font_size_16 word_break gray_scale_1'>${parseFloat(ingredient.cost).toFixed(2)}</p>
                                <p className='font_size_16 word_break gray_scale_1'>{ingredient.unit_name}</p>
                                <p className='font_size_16 word_break gray_scale_1'>{parseFloat(ingredient.calories).toFixed(2)}</p>
                                <p className='font_size_16 word_break gray_scale_1'>{parseFloat(ingredient.carb).toFixed(2)}</p>
                                <p className='font_size_16 word_break gray_scale_1'>{parseFloat(ingredient.fat).toFixed(2)}</p>
                                <p className='font_size_16 word_break gray_scale_1'>{parseFloat(ingredient.protein).toFixed(2)}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </FullScreenOverlay>
        </div>
    );
}


export default SelectedIngredientModal;